import FlightIcon from "@mui/icons-material/Flight";
import HotelIcon from "@mui/icons-material/Hotel";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import StarPurple500Icon from "@mui/icons-material/StarPurple500";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const items = [
  {
    icon: <FlightIcon className="rotate-[45deg]" color="primary" />,
    title: "Fastest Real-time Award Search Engine",
    description:
      "Discover the best ways to use your points in just 20 seconds with the most advanced real-time award search engine that searches 32 entries in one shot.",
  },
  {
    icon: <NotificationsActiveIcon color="primary" />,
    title: "Awesome AwardTool Advanced Alerts",
    description:
      "Set it and forget it. We search daily and notify you via email and SMS when your ideal flight and hotel deals are available.",
  },
  {
    icon: <StarPurple500Icon color="primary" />,
    title: "Explore the world with Panorama",
    description:
      "Search across unlimited regions, cities, and airports with a 90-day range for over 40,000 popular routes.",
  },
  {
    icon: <HotelIcon color="primary" />,
    title: "Award Hotel Stays",
    description:
      "Enhance your award travel experience with our curated selection of top-notch hotel stays.",
  },
];

export default function Content() {
  return (
    <Stack
      sx={{
        flexDirection: "column",
        alignSelf: "center",
        gap: 3,
        maxWidth: 450,
        // backgroundImage: 'https://www.williamlong.info/google/upload/813_2.jpg',
        // backgroundImage: 'url("https://www.williamlong.info/google/upload/813_2.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: 0,
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
        <img
          src="https://img.awardtool-api.com/awardtool_logo.jpg"
          alt="Sitemark"
          style={{ height: 80, borderRadius: "8px" }}
        />
        <Typography sx={{ marginLeft: 1, fontWeight: "bold" }} color="primary">
          AwardTool
        </Typography>
      </Box>
      <Typography sx={{ fontWeight: "bold", color: "text.primary", mt: -2 }}>
        Save thousands of dollars and hours of time with AwardTool! 🏨 ✈️
      </Typography>
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: 600, color: "text.primary" }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}
